import * as css from 'css/exports.module.scss';
import { coreActions } from '@sonar-software/sonar-core';
import { INITIATIVES_SIDEBAR_LABELS } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { SonarTagDisplay } from '@ui/tags';
import { SonarText } from '@ui/text';
import { Space } from 'antd';
import { useAction, useInitiativeReferenceSelect, useOnMount } from '@hooks';
export const InitiativeTagsSection = ({ initiativeId }) => {
    const tagIds = useInitiativeReferenceSelect(initiativeId, (initiative) => initiative.tagIds);
    const getTags = useAction(coreActions.requestGetCoreInitiativesTags);
    useOnMount(() => {
        getTags({
            initiativeId: initiativeId
        });
    });
    if (!tagIds.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(SonarText, { className: 'section-header' }, INITIATIVES_SIDEBAR_LABELS.TAGS),
        React.createElement(Space, { size: Number(css.size2), wrap: true }, tagIds.map((tagId) => React.createElement(SonarTagDisplay, { key: tagId, tagId: tagId })))));
};
